if (!customElements.get('product-personalization')) {
  customElements.define('product-personalization', class extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.originalNoValidate = this.form.noValidate;
      this.form.noValidate = false;
      this.controls = [...this.querySelectorAll('[data-personalization-control]')];
      this.previewUrls = new WeakMap();
      if (this.controls.some((control) => control.type === 'file')) this.form.enctype = 'multipart/form-data';
      this.validateFile = (event) => {
        const input = event.target;
        const label = input.closest('[data-personalization-field]')?.querySelector('[data-file-label]');
        if (label) label.textContent = input.files[0]?.name || 'Choose and upload photo...';
        const action = input.closest('[data-personalization-field]')?.querySelector('[data-file-action]');
        if (action) action.textContent = input.files[0] ? 'Edit' : 'Select Photo';
        const preview = input.closest('[data-personalization-field]')?.querySelector('[data-file-preview]');
        const image = preview?.querySelector('[data-file-preview-image]');
        if (this.previewUrls.has(input)) URL.revokeObjectURL(this.previewUrls.get(input));
        if (input.files[0]?.type.startsWith('image/')) {
          const url = URL.createObjectURL(input.files[0]);
          this.previewUrls.set(input, url);
          if (image) image.src = url;
          if (preview) preview.hidden = false;
        } else if (preview) preview.hidden = true;
        const maxSize = Number(input.dataset.maxSize || 0);
        input.setCustomValidity(maxSize && input.files[0] && input.files[0].size > maxSize
          ? `Please choose a file smaller than ${Math.round(maxSize / 1048576)} MB.` : '');
        const error = input.closest('[data-personalization-field]')?.querySelector('[data-personalization-error]');
        if (error && input.files[0]) error.hidden = true;
      };
      this.controls.forEach((control) => control.addEventListener('change', this.validateFile));
      this.validate = (event) => {
        this.updateConditions();
        const missingFile = [...this.querySelectorAll('[data-personalization-field]:not([hidden]) input[type="file"][data-required="true"]')]
          .find((input) => !input.disabled && !input.files?.length);
        if (missingFile) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const error = missingFile.closest('[data-personalization-field]')?.querySelector('[data-personalization-error]');
          if (error) error.hidden = false;
          missingFile.focus({ preventScroll: true });
          missingFile.closest('[data-personalization-field]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (!this.form.reportValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      this.form.addEventListener('submit', this.validate, true);
      this.onInput = () => this.updateConditions();
      this.addEventListener('change', this.onInput);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section || !data.variant) return;
        this.variant = data.variant;
        this.updateConditions();
      });
      this.updateConditions();
    }
    fieldValue(field) {
      const controls = [...field.querySelectorAll('[data-personalization-control]')].filter((control) => !control.disabled);
      const checked = controls.find((control) => (control.type === 'radio' ? control.checked : true));
      if (!checked) return '';
      return checked.type === 'file' ? (checked.files[0]?.name || '') : checked.value;
    }
    conditionMatches(field) {
      const optionIndex = Number(field.dataset.conditionOptionIndex);
      if (optionIndex) {
        const selected = this.variant?.options?.[optionIndex - 1] ?? this.variant?.[`option${optionIndex}`];
        if (selected !== field.dataset.conditionOptionValue) return false;
      }
      if (field.dataset.conditionField) {
        const dependency = this.querySelector(`[data-field-key="${CSS.escape(field.dataset.conditionField)}"]`);
        if (!dependency || this.fieldValue(dependency) !== field.dataset.conditionFieldValue) return false;
      }
      return true;
    }
    updateConditions() {
      this.querySelectorAll('[data-personalization-field]').forEach((field) => {
        const visible = this.conditionMatches(field);
        field.hidden = !visible;
        field.querySelectorAll('[data-personalization-control]').forEach((control) => {
          control.disabled = !visible;
          control.required = visible && control.dataset.required === 'true';
          if (!visible && control.type === 'file') control.value = '';
          if (!visible && control.type === 'file') {
            const label = field.querySelector('[data-file-label]');
            if (label) label.textContent = 'Choose and upload photo...';
            const action = field.querySelector('[data-file-action]');
            if (action) action.textContent = 'Select Photo';
            const preview = field.querySelector('[data-file-preview]');
            if (preview) preview.hidden = true;
            if (this.previewUrls.has(control)) URL.revokeObjectURL(this.previewUrls.get(control));
            this.previewUrls.delete(control);
          }
          if (!visible && control.type !== 'file' && control.type !== 'radio') control.value = '';
          if (!visible && control.type === 'radio') control.checked = false;
        });
      });
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.form?.removeEventListener('submit', this.validate, true);
      this.removeEventListener('change', this.onInput);
      this.controls?.forEach((control) => control.removeEventListener('change', this.validateFile));
      this.controls?.forEach((control) => { if (this.previewUrls?.has(control)) URL.revokeObjectURL(this.previewUrls.get(control)); });
      if (this.form) this.form.noValidate = this.originalNoValidate;
    }
  });
}
